/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FlaggedItemObjectType,
    FlaggedItemObjectTypeFromJSON,
    FlaggedItemObjectTypeFromJSONTyped,
    FlaggedItemObjectTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateUserNotificationRequestDto
 */
export interface CreateUserNotificationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserNotificationRequestDto
     */
    flaggedItemId: string | null;
    /**
     * 
     * @type {FlaggedItemObjectType}
     * @memberof CreateUserNotificationRequestDto
     */
    type: FlaggedItemObjectType;
    /**
     * 
     * @type {string}
     * @memberof CreateUserNotificationRequestDto
     */
    text: string | null;
}

export function CreateUserNotificationRequestDtoFromJSON(json: any): CreateUserNotificationRequestDto {
    return CreateUserNotificationRequestDtoFromJSONTyped(json, false);
}

export function CreateUserNotificationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserNotificationRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'flaggedItemId': json['flaggedItemId'],
        'type': FlaggedItemObjectTypeFromJSON(json['type']),
        'text': json['text'],
    };
}

export function CreateUserNotificationRequestDtoToJSON(value?: CreateUserNotificationRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'flaggedItemId': value.flaggedItemId,
        'type': FlaggedItemObjectTypeToJSON(value.type),
        'text': value.text,
    };
}


